import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./scss/global.scss";
import PrivateRoutes from "./routes/PrivateRoutes";
import EntryRoutes from "./routes/EntryRoutes/index";
import { ModalProvider } from "./components/ModalContext";
import { DashboardStateProvider } from "components/DashboardContext";
import { statusCheck } from "./store/actions/user";

function App() {
  const auth = useSelector((state) => state.user.status);
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(statusCheck());
  }, []);

  return (
    <DashboardStateProvider>
      {
        auth !== null &&
        <ModalProvider>
          {auth
            ? <PrivateRoutes />
            : <EntryRoutes />
          }
        </ModalProvider>
      }
    </DashboardStateProvider>
  );
}

export default App;
